import { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import LoadingPlaceHolder from '../../../components/LoadingPlaceHolder';
import { useStorageDocuments, useStorageLots } from './queries';

const DOC_NAME_MAP = {
  StorageContract: 'Storage Contract',
  HouseholdGoods: 'Household Goods',
};

function StorageDocuments() {
  const { isFetching: isFetchingLots, data: lotsData } = useStorageLots();
  const { isFetching: isFetchingDocs, data: docsData } = useStorageDocuments();
  const [activeLot, setActiveLot] = useState(null);
  const [activeLotDocs, setActiveLotDocs] = useState([]);

  useEffect(() => {
    if (!activeLot && lotsData?.length > 0) {
      setActiveLot(lotsData[0]);
    }
  }, [lotsData]);

  useEffect(() => {
    if (activeLot && docsData) {
      if (activeLot) {
        setActiveLotDocs(
          docsData.filter(
            (doc) => doc.ShipmentNumber === activeLot.ShipmentNumber
          )
        );
      }
    }
  }, [activeLot, docsData]);

  const isReady = !isFetchingLots && !isFetchingDocs;

  return (
    <div className="portal-inner has-tabs">
      <Row>
        <Col xl={9}>
          <div className="info-box">
            <div className="info-header">
              <h3>Documents</h3>
              {!isFetchingLots && lotsData?.length && (
                <Form className="w-50">
                  <Form.Group as={Row}>
                    <Form.Label column sm="1" className="text-light">
                      Lot
                    </Form.Label>
                    <Col sm="11">
                      <Form.Select
                        value={activeLot?.InventoryLotID || ''}
                        style={{ lineHeight: '2em' }}
                        onChange={(e) => {
                          setActiveLot(
                            lotsData.find(
                              (lot) => lot.InventoryLotID === e.target.value
                            )
                          );
                        }}
                      >
                        {lotsData.map((lot) => (
                          <option
                            key={lot.InventoryLotID}
                            value={lot.InventoryLotID}
                          >
                            {lot.LotName}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                </Form>
              )}
            </div>
            <div className="info-content">
              {!isReady && <LoadingPlaceHolder isVisible />}
              {isReady && (
                <>
                  <h3 className="mb-4">{activeLot?.LotName}</h3>
                  {!activeLotDocs?.length && <p>No documents found.</p>}

                  {activeLotDocs.map((doc) => (
                    <Row className="mb-3">
                      <Col sm="7">
                        {DOC_NAME_MAP[doc.Descriptor] ||
                          doc.Descriptor ||
                          'Document'}
                      </Col>
                      <Col sm="5">
                        <a
                          href={doc?.e[0]?.linkToFile}
                          target="_blank"
                          rel="noreferrer"
                        >
                          download
                        </a>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StorageDocuments;
